const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60;

function readCookie(name) {
  const match = document.cookie.match(
    new RegExp(`(^|;\\s*)${name}=([^;]+)`)
  );

  return match ? decodeURIComponent(match[2]) : null;
}

function writeCookie(name, value, maxAgeSeconds) {
  const secureFlag = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie =
    `${name}=${encodeURIComponent(value)}; ` +
    `Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax${secureFlag}`;
}

export function generateEventId(prefix = "meta") {
  const randomPart =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  return `${prefix}_${randomPart}`;
}

export function getFbp() {
  return readCookie("_fbp");
}

export function getFbc() {
  return readCookie("_fbc");
}

export function ensureFbcFromFbclid() {
  const params = new URLSearchParams(window.location.search);
  const fbclid = params.get("fbclid");

  if (!fbclid) {
    return getFbc();
  }

  const existing = getFbc();
  if (existing) {
    return existing;
  }

  const fbc = `fb.1.${Date.now()}.${fbclid}`;
  writeCookie("_fbc", fbc, COOKIE_MAX_AGE_SECONDS);
  return fbc;
}

function injectPixelBaseScript() {
  if (typeof window === "undefined" || window.fbq || !PIXEL_ID) {
    return;
  }

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

  window.fbq("init", PIXEL_ID);
}

export function initMetaPixel() {
  injectPixelBaseScript();
  ensureFbcFromFbclid();
}

export function trackPageView() {
  if (!PIXEL_ID) {
    return;
  }

  injectPixelBaseScript();
  window.fbq("track", "PageView");
}

export function getBrowserMeta(extra = {}) {
  return {
    fbp: getFbp(),
    fbc: ensureFbcFromFbclid(),
    eventSourceUrl: window.location.href,
    ...extra,
  };
}

export function trackStandardEvent(eventName, payload = {}, eventId) {
  if (!PIXEL_ID || !window.fbq) {
    return;
  }

  window.fbq("track", eventName, payload, {
    eventID: eventId,
  });
}

export function trackCustomEvent(eventName, payload = {}, eventId) {
  if (!PIXEL_ID || !window.fbq) {
    return;
  }

  window.fbq("trackCustom", eventName, payload, {
    eventID: eventId,
  });
}
